import { Reducer } from "redux";
import { Location } from 'history'

export const STASH_LOCATION_SAVE = 'OD/STASH_LOCATION_SAVE'
export const STASH_LOCATION_CLEAR = 'OD/STASH_LOCATION_CLEAR'


export interface StashLocationSaveAction {
  readonly type: typeof STASH_LOCATION_SAVE;
  readonly payload: Location;
}

export interface StashLocationClearAction {
  readonly type: typeof STASH_LOCATION_CLEAR;
}


type ActionTypes =
  | StashLocationSaveAction
  | StashLocationClearAction


export type State = { location: Location } | null

const initialState = null

export const stashLocationReducer: Reducer<State, ActionTypes> = (
  previousState = initialState,
  action
) => {
  switch (action.type) {

    case STASH_LOCATION_SAVE:
      return { location: action.payload }
    case STASH_LOCATION_CLEAR:
      return null
    default:
      return previousState;
  }
}

export const getStashedLocation = (state:any) => state.od.stashLocation as State;

